import { getCookie, setCookie } from './cookie'

// TODO: remove file if not necessary
export function ga(method, ...args) {
  const GA =
    typeof window === 'undefined' || typeof window.ga === 'undefined'
      ? () => {
          console.log('GA', method, args)
        }
      : window.ga

  GA(method, ...args)
}

export function gtm(data) {
  const DataLayer =
    typeof window === 'undefined' || typeof window.dataLayer === 'undefined'
      ? {
          push: () => {
            console.log('gtm', 'push', data)
          }
        }
      : window.dataLayer

  DataLayer.push(data)
}

export const generateUUID = () => {
  // adopted from https://stackoverflow.com/a/105078/1807763
  let result = ''

  for (let j = 0; j < 32; j++) {
    if (j === 8 || j === 12 || j === 16 || j === 20) result = `${result}-`
    const i = Math.floor(Math.random() * 16)
      .toString(16)
      .toUpperCase()
    result = result + i
  }

  return result
}

const analyticsCookieName = 'aId'

export const getAnalyticsId = () => getCookie(analyticsCookieName)

export const setAnalyticsId = () => {
  let analyticsId = getAnalyticsId()
  if (!analyticsId) {
    // put test id in cookie if not already there
    analyticsId = generateUUID()
    const expDate = new Date()
    expDate.setFullYear(expDate.getFullYear() + 100) // should not expire for a user
    setCookie(analyticsCookieName, analyticsId, '/', expDate)
  }
  return analyticsId
}
